import React, { Component } from 'react';
import construct from '../construction.png';
import '../App.css';
class Articles extends React.Component {
	render() {
		return (
			<div>
			<img src={construct} className="App-logo" alt="work in progress.." />
			<h1> Work in progress..</h1>
			</div>
			);
		}
	}

	export default Articles;


// WEBPACK FOOTER //
// ./src/writeups/articles.js